import styled from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  height: 100%;
`;

export const UserCredentials = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: ${grid.xxl};
  padding-right: 32px;
`;

export const Box = styled.div`
  display: flex;
  width: 100%;
`;

export const AvatarBox = styled.div`
  width: 65%;
  display: flex;
  justify-content: end;
`;

export const EditBox = styled.div`
  width: 35%;
  display: flex;
  justify-content: end;
`;

export const UserInformation = styled.div`
  background: #f2f2f2;
  height: 100%;
`;

export const Top = styled.div`
  height: 55%;
  border-bottom: 2px solid #e6e6e6;
  padding: ${grid.xxl} ${grid.lg};

  h2 {
    font-size: 16px;
    font-weight: 600;
    color: #4d4d4d;
    margin: 0;
    margin-bottom: ${grid.lg};
  }
`;

export const Bottom = styled.div`
  height: 45%;
  padding: ${grid.xxl} ${grid.lg} ${grid.lg} ${grid.lg};

  h2 {
    font-size: 16px;
    font-weight: 600;
    color: #4d4d4d;
    margin: 0;
    margin-bottom: ${grid.lg};
  }
`;

export const Items = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  row-gap: ${grid.lg};
  column-gap: ${grid.lg};

  .undefinedItem {
    div:last-child {
      span {
        font-style: italic;
        padding-right: 10px;
      }
    }
  }
`;

export const ItemsSkelleton = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  row-gap: 28px;
  column-gap: 28px;
  margin-top: 36px;
`;

export const EditIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${grid.xl};
  width: ${grid.xl};
  background: transparent;
  border: none;

  &:hover {
    background: #f0113c4d;
    border-radius: 5px;
  }
`;

export const UserName = styled.h2`
  font-size: 24px;
  font-weight: normal;
  color: #1a1a1a;
  margin: ${grid.md} 0 ${grid.lg} 0;
  text-align: center;
`;

export const UserRole = styled.p`
  font-size: 16px;
  margin: 0;
`;

export const UserEmailContact = styled.span`
  color: ${colors.primary};
  margin: 8px 0;
  border-bottom: 1px solid ${colors.primary};
`;
